import { render, staticRenderFns } from "./DropdownLanguage.vue?vue&type=template&id=942ba27e&"
import script from "./DropdownLanguage.vue?vue&type=script&lang=js&"
export * from "./DropdownLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports